import { Icon } from "./Icon.tsx";

/** A stamp/template glyph, distinct from OptionsIcon.tsx's slider (simulation options vs. what a new element starts out with). */
export function DefaultsIcon() {
  return (
    <Icon>
      <rect x="4" y="3" width="16" height="12" rx="2" />
      <path d="M9 21h6M12 15v6" />
    </Icon>
  );
}
